export default __webpack_public_path__ + "34baad14557bad6b40020117915dc09a.png";